const echarts = require("echarts");

export default function (data, name) {
  var fontColor = "#fff";
  return {
    backgroundColor: "",
    textStyle: {
      fontSize: 18,
    },
    title: {
      show: false,
      text: "",
      left: "left",
      textStyle: {
        color: fontColor,
        align: "center",
      },
    },
    grid: {
      left: "20",
      right: "50",
      bottom: "50",
      top: "50",
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
        label: {
          show: true,
          backgroundColor: "#333",
        },
      },
    },
    legend: {
      show: true,
      x: "center",
      top: "10",
      textStyle: {
        color: fontColor,
        fontSize: "8",
      },
      data: name,
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: true,
        axisLabel: {
          color: fontColor,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "rgb(10, 115, 255)",
          },
        },
        data: ["01月", "02月", "03月", "04月", "05月"],
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "",
        axisLine: {
          lineStyle: {
            color: fontColor,
          },
        },
      },
    ],
    series: [
      {
        name: name[0],
        type: "line",
        symbolSize: 4,
        label: {
          normal: {
            show: false,
            position: "top",
          },
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 0,
              color: "rgba(7,46,101,0.3)",
            },
            {
              offset: 1,
              color: "rgba(0,166,246,0.9)",
            },
          ]),
          areaStyle: {
            type: "default",
            opacity: 0.1,
          },
        },
        itemStyle: {
          normal: {
            color: "rgb(10, 115, 255)",
          },
        },
        data: data[0],
      },
      {
        name: name[1],
        type: "line",
        stack: "总量",
        symbol: "circle",
        symbolSize: 4,
        label: {
          normal: {
            show: false,
            position: "top",
          },
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 0,
              color: "rgba(7,44,90,0.3)",
            },
            {
              offset: 1,
              color: "rgba(0,212,199,0.9)",
            },
          ]),
          areaStyle: {
            type: "default",
            opacity: 0.1,
          },
        },
        itemStyle: {
          normal: {
            color: "rgb(121, 218, 255)",
          },
        },
        data: data[1],
      },
    ],
  };
}
